import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

/**
 * Game Favorite Store
 */
export const useGameFavoriteStore = defineStore('gameFavorite', () => {
  // State
  const favorites = ref([]) // 收藏的遊戲列表
  const favoriteCodesSet = ref(new Set()) // 用於快速查找的 Set

  // Getters
  /**
   * 獲取收藏列表
   */
  const favoriteList = computed(() => favorites.value)

  /**
   * 檢查遊戲是否已收藏 - O(1) 時間複雜度
   */
  const hasFavorite = computed(() => (gameCode) => {
    if (!gameCode) return false
    return favoriteCodesSet.value.has(gameCode)
  })

  // Actions
  /**
   * 設置收藏列表
   */
  function setFavorites(games) {
    favorites.value = games || []
    // 同步更新 Set
    favoriteCodesSet.value = new Set(favorites.value.map((game) => game.gameCode).filter(Boolean))
  }

  /**
   * 添加到收藏列表
   */
  function addFavorite(game) {
    if (!game?.gameCode) {
      console.warn('[gameFavorite] Invalid game object:', game)
      return
    }

    // 防止重複添加
    if (favoriteCodesSet.value.has(game.gameCode)) {
      return
    }

    favorites.value.push(game)
    favoriteCodesSet.value.add(game.gameCode)
  }

  /**
   * 從收藏列表移除
   */
  function removeFavorite(gameCode) {
    if (!gameCode) {
      console.warn('[gameFavorite] Invalid gameCode:', gameCode)
      return
    }

    favorites.value = favorites.value.filter((item) => item.gameCode !== gameCode)
    favoriteCodesSet.value.delete(gameCode)
  }

  /**
   * 清空收藏列表
   */
  function clearFavorites() {
    favorites.value = []
    favoriteCodesSet.value.clear()
  }

  return {
    // State
    favorites,
    // Getters
    favoriteList,
    hasFavorite,
    // Actions
    setFavorites,
    addFavorite,
    removeFavorite,
    clearFavorites,
  }
})
